// Утилиты для работы с изображениями товаров маркетплейсов

const MP_MAP = { 1: 'WB', 2: 'OZ', 3: 'YA' };
const MP_COLORS = { 1: '#CB11AB', 2: '#005BFF', 3: '#FFCC00' };
const MP_TEXT_COLORS = { 1: '#fff', 2: '#fff', 3: '#000' };

export { MP_MAP, MP_COLORS, MP_TEXT_COLORS };

/**
 * Построить URL миниатюры карточки товара Wildberries по nmID.
 * Использует CDN basket-XX.wbbasket.ru/volNNN/partMMM/<id>/images/c246x328/1.webp
 */
export function getWbImageUrl(nmId) {
  if (!nmId) return null;
  const id = Number(nmId);
  const vol = Math.floor(id / 100000);
  const part = Math.floor(id / 1000);
  let basket;
  if (vol <= 143) basket = '01';
  else if (vol <= 287) basket = '02';
  else if (vol <= 431) basket = '03';
  else if (vol <= 719) basket = '04';
  else if (vol <= 1007) basket = '05';
  else if (vol <= 1061) basket = '06';
  else if (vol <= 1115) basket = '07';
  else if (vol <= 1169) basket = '08';
  else if (vol <= 1313) basket = '09';
  else if (vol <= 1601) basket = '10';
  else if (vol <= 1655) basket = '11';
  else if (vol <= 1919) basket = '12';
  else if (vol <= 2045) basket = '13';
  else if (vol <= 2189) basket = '14';
  else if (vol <= 2405) basket = '15';
  else if (vol <= 2621) basket = '16';
  else if (vol <= 2837) basket = '17';
  else basket = '18';
  return `https://basket-${basket}.wbbasket.ru/vol${vol}/part${part}/${id}/images/c246x328/1.webp`;
}

/**
 * Привести URL изображения к миниатюре где это возможно.
 * Сейчас обрабатывает avatars.mds.yandex.net (заменяет /orig на /200x200).
 */
export function toThumbnail(url) {
  if (!url) return url;
  if (url.includes('avatars.mds.yandex.net')) return url.replace(/\/orig$/, '/200x200');
  return url;
}

/**
 * Подобрать лучший URL картинки для строки товара из /products/list.
 * Предпочитает image_url из БД, иначе генерирует WB-CDN URL.
 */
export function pickProductImage(row) {
  if (!row) return null;
  const mpList = Array.isArray(row.mp_list) ? row.mp_list : [];
  if (row.image_url) return toThumbnail(row.image_url);
  if (mpList.includes(1) && row.wb_product_id) return getWbImageUrl(row.wb_product_id);
  return null;
}
